<!-- Adicione a classe da fonte principal ao body ou a este container se não for global -->
<div class="landing-page font-montserrat text-primary relative overflow-hidden flex flex-col justify-center">

  <!-- Top Container -->
  <div class="top-container bg-primary text-surface min-h-screen">
    <div class="py-4 px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 lg:pt-20 z-2">
      <!-- Seção Home -->
      <div id="home"
        class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-between mb-6 py-6 md:mb-8 md:py-8 md:ml-8">
        <!-- Coluna Esquerda (Texto e Botão) -->
        <div
          class="w-full md:w-auto flex flex-col gap-4 order-last md:order-first items-center md:items-start text-center md:text-left lg:w-4/6 lg:ml-12">
          <div pAnimateOnScroll [enterClass]="'animate__animated animate__fadeIn'" [leaveClass]="'animate__fadeOut'"
            style="animation-delay: 100ms;">
            <img class="logo mb-3 w-86" src="/images/landing/aiaslogocompleto.png" alt="AIAS Logo">
          </div>
          <span class="descriptionSystem block font-normal text-6xl mb-3 text-center text-white">{{
            "module.landingPage.descriptionQuestion" | transloco }}</span>

          <span class="descriptionSystem block font-normal text-xl mb-5 text-justify text-white">{{
            "module.landingPage.descriptionSystem" | transloco }}</span>
          <!-- Botão Convertido -->
          <button
            class="button flex justify-center items-center bg-surface rounded-[3.4rem] px-6 py-3 w-73 text-center shadow-shine text-primary text-xl font-medium border-0 hover:bg-gray-light transition-colors"
            (click)="this.login()">{{ 'general.singular.enter' | transloco }}</button>
        </div>

        <!-- Coluna Direita (Imagem) -->
        <div class="w-full lg:w-5/6 lg:mr-6 order-first md:order-last mb-6 md:mb-0">
          <div pAnimateOnScroll [enterClass]="'animate__animated animate__fadeIn'" [leaveClass]="'animate__fadeOut'"
            style="animation-delay: 200ms;">
            <img src="/images/landing/auditoria.png" alt="" class="w-full h-auto block" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção Features -->
  <div class="features bg-surface mx-0 md:mx-6 lg:mx-8 my-2 py-4 md:my-6 md:py-6">
    <div class="flex flex-col items-center">
      <span class="text-primary block font-bold text-5xl mb-1 text-center">{{ "module.landingPage.offersQuestion" |
        transloco }}
      </span>
      <!-- Largura customizada convertida para valor arbitrário -->
      <span class="text-primary block text-xl mb-8 text-justify leading-8 w-full max-w-189">{{
        "module.landingPage.offersDescription" |
        transloco}}</span>
    </div>

    <!-- Grid de Features -->
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
      <!-- Card 1 -->
      <div class="w-full p-3">
        <!-- Classes surface/border convertidas -->
        <div class="flex flex-col items-center p-4 w-full h-full bg-white border border-gray-200 rounded-lg">
          <!-- SVG com fill convertido -->
          <svg width="80" height="107" viewBox="0 0 80 107" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="fill-primary">
            <path
              d="M40 0C31.2917 0 23.875 5.53576 21.1458 13.2692H13.3333C5.97917 13.2692 0 19.2197 0 26.5385V92.8846C0 100.203 5.97917 106.154 13.3333 106.154H66.6667C74.0208 106.154 80 100.203 80 92.8846V26.5385C80 19.2197 74.0208 13.2692 66.6667 13.2692H58.8542C56.125 5.53576 48.7083 0 40 0ZM40 13.2692C41.7681 13.2692 43.4638 13.9682 44.714 15.2125C45.9643 16.4567 46.6667 18.1442 46.6667 19.9038C46.6667 21.6635 45.9643 23.351 44.714 24.5952C43.4638 25.8395 41.7681 26.5385 40 26.5385C38.2319 26.5385 36.5362 25.8395 35.286 24.5952C34.0357 23.351 33.3333 21.6635 33.3333 19.9038C33.3333 18.1442 34.0357 16.4567 35.286 15.2125C36.5362 13.9682 38.2319 13.2692 40 13.2692ZM15 56.3942C15 55.0745 15.5268 53.8089 16.4645 52.8757C17.4021 51.9425 18.6739 51.4183 20 51.4183C21.3261 51.4183 22.5979 51.9425 23.5355 52.8757C24.4732 53.8089 25 55.0745 25 56.3942C25 57.7139 24.4732 58.9796 23.5355 59.9128C22.5979 60.8459 21.3261 61.3702 20 61.3702C18.6739 61.3702 17.4021 60.8459 16.4645 59.9128C15.5268 58.9796 15 57.7139 15 56.3942ZM36.6667 53.0769H63.3333C65.1667 53.0769 66.6667 54.5697 66.6667 56.3942C66.6667 58.2188 65.1667 59.7115 63.3333 59.7115H36.6667C34.8333 59.7115 33.3333 58.2188 33.3333 56.3942C33.3333 54.5697 34.8333 53.0769 36.6667 53.0769ZM15 76.2981C15 74.9784 15.5268 73.7127 16.4645 72.7795C17.4021 71.8464 18.6739 71.3221 20 71.3221C21.3261 71.3221 22.5979 71.8464 23.5355 72.7795C24.4732 73.7127 25 74.9784 25 76.2981C25 77.6178 24.4732 78.8834 23.5355 79.8166C22.5979 80.7498 21.3261 81.274 20 81.274C18.6739 81.274 17.4021 80.7498 16.4645 79.8166C15.5268 78.8834 15 77.6178 15 76.2981ZM33.3333 76.2981C33.3333 74.4736 34.8333 72.9808 36.6667 72.9808H63.3333C65.1667 72.9808 66.6667 74.4736 66.6667 76.2981C66.6667 78.1226 65.1667 79.6154 63.3333 79.6154H36.6667C34.8333 79.6154 33.3333 78.1226 33.3333 76.2981Z" />
          </svg>
          <span class="text-center my-4 text-primary text-lg font-semibold">{{
            "menu.auditoria.jornadaAuditor.escopoJornada.label" | transloco }}
          </span>
          <span class="text-justify text-primary text-lg">{{ "module.landingPage.escopoJornadaDescription" | transloco
            }}
          </span>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="w-full p-3">
        <div class="flex flex-col items-center p-4 w-full h-full bg-white border border-gray-200 rounded-lg">
          <svg width="80" height="107" viewBox="0 0 80 107" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="fill-primary">
            <path
              d="M40 0C31.2917 0 23.875 5.55025 21.1458 13.304H13.3333C5.97917 13.304 0 19.27 0 26.6079V93.1278C0 100.466 5.97917 106.432 13.3333 106.432H66.6667C74.0208 106.432 80 100.466 80 93.1278V26.6079C80 19.27 74.0208 13.304 66.6667 13.304H58.8542C56.125 5.55025 48.7083 0 40 0ZM40 13.304C41.7681 13.304 43.4638 14.0048 44.714 15.2523C45.9643 16.4998 46.6667 18.1917 46.6667 19.9559C46.6667 21.7202 45.9643 23.4121 44.714 24.6596C43.4638 25.9071 41.7681 26.6079 40 26.6079C38.2319 26.6079 36.5362 25.9071 35.286 24.6596C34.0357 23.4121 33.3333 21.7202 33.3333 19.9559C33.3333 18.1917 34.0357 16.4998 35.286 15.2523C36.5362 14.0048 38.2319 13.304 40 13.304ZM39.0208 40.8889C40.3125 42.1777 40.3125 44.298 39.0208 45.5869L25.6875 58.8908C24.3958 60.1796 22.2708 60.1796 20.9792 58.8908L14.3125 52.2388C13.0208 50.95 13.0208 48.8297 14.3125 47.5409C15.6042 46.2521 17.7292 46.2521 19.0208 47.5409L23.3333 51.8439L34.3125 40.8889C35.6042 39.6001 37.7292 39.6001 39.0208 40.8889ZM40 56.5419C40 54.7126 41.5 53.2159 43.3333 53.2159H63.3333C65.1667 53.2159 66.6667 54.7126 66.6667 56.5419C66.6667 58.3711 65.1667 59.8678 63.3333 59.8678H43.3333C41.5 59.8678 40 58.3711 40 56.5419ZM36.6667 73.1718H63.3333C65.1667 73.1718 66.6667 74.6685 66.6667 76.4978C66.6667 78.3271 65.1667 79.8238 63.3333 79.8238H36.6667C34.8333 79.8238 33.3333 78.3271 33.3333 76.4978C33.3333 74.6685 34.8333 73.1718 36.6667 73.1718ZM15 76.4978C15 75.1746 15.5268 73.9057 16.4645 72.9701C17.4021 72.0344 18.6739 71.5088 20 71.5088C21.3261 71.5088 22.5979 72.0344 23.5355 72.9701C24.4732 73.9057 25 75.1746 25 76.4978C25 77.821 24.4732 79.0899 23.5355 80.0255C22.5979 80.9612 21.3261 81.4868 20 81.4868C18.6739 81.4868 17.4021 80.9612 16.4645 80.0255C15.5268 79.0899 15 77.821 15 76.4978Z" />
          </svg>
          <span class="text-center my-4 text-primary text-lg font-semibold">{{
            "menu.auditoria.jornadaAuditor.gerenciamentoAuditoria.label" | transloco }}</span>
          <span class="text-justify text-primary text-lg">{{ "module.landingPage.gerenciamentoAuditoriaDescription" |
            transloco }}
          </span>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="w-full p-3">
        <div class="flex flex-col items-center p-4 w-full h-full bg-white border border-gray-200 rounded-lg">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="fill-primary">
            <path
              d="M70 20C72.6522 20 75.1957 18.9464 77.0711 17.0711C78.9464 15.1957 80 12.6522 80 10C80 7.34784 78.9464 4.8043 77.0711 2.92893C75.1957 1.05357 72.6522 0 70 0C67.3478 0 64.8043 1.05357 62.9289 2.92893C61.0536 4.8043 60 7.34784 60 10C60 12.6522 61.0536 15.1957 62.9289 17.0711C64.8043 18.9464 67.3478 20 70 20ZM20 5C8.95312 5 0 13.9531 0 25C0 36.0469 8.95312 45 20 45H60C65.5156 45 70 49.4844 70 55C70 59.3594 67.2031 63.0781 63.3125 64.4375C61.5156 61.7656 58.4688 60 55 60C49.4844 60 45 64.4844 45 70C45 75.5156 49.4844 80 55 80C58.8594 80 62.2031 77.8125 63.875 74.625C73.0625 72.8281 80 64.7188 80 55C80 43.9531 71.0469 35 60 35H20C14.4844 35 10 30.5156 10 25C10 19.4844 14.4844 15 20 15H40V17.2031C40 18.75 41.25 20 42.7969 20C43.4219 20 44.0156 19.7969 44.5156 19.4062L54.0156 12.0156C54.6406 11.5312 55 10.7812 55 10C55 9.21875 54.6406 8.46875 54.0156 7.98438L44.5 0.59375C44.0156 0.21875 43.4062 0 42.7812 0C41.25 0 40 1.25 40 2.79688V5H20ZM18.6563 65C16.9219 62.0156 13.7031 60 10 60C4.48438 60 0 64.4844 0 70C0 75.5156 4.48438 80 10 80C13.7031 80 16.9375 77.9844 18.6563 75H25V77.2031C25 78.75 26.25 80 27.7969 80C28.4219 80 29.0156 79.7969 29.5156 79.4062L39.0156 72.0156C39.6406 71.5312 40 70.7812 40 70C40 69.2188 39.6406 68.4688 39.0156 67.9844L29.5156 60.5938C29.0312 60.2188 28.4219 60 27.7969 60C26.25 60 25 61.25 25 62.7969V65H18.6563Z" />
          </svg>

          <span class="text-center my-4 text-primary text-lg font-semibold">{{
            "menu.auditoria.jornadaAuditor.acompanhamentoMContinua.label"
            |
            transloco }}</span>
          <span class="text-justify text-primary text-lg">{{ "module.landingPage.acompanhamentoMContinuaDescription" |
            transloco }}
          </span>
        </div>
      </div>

      <!-- Card 4 -->
      <div class="w-full p-3">
        <div class="flex flex-col items-center p-4 w-full h-full bg-white border border-gray-200 rounded-lg">
          <svg width="80" height="92" viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="fill-primary">
            <path
              d="M17.1429 0C7.67857 0 0 7.68924 0 17.1667V74.3889C0 83.8663 7.67857 91.5556 17.1429 91.5556H68.5714H74.2857C77.4464 91.5556 80 88.9984 80 85.8333C80 82.6682 77.4464 80.1111 74.2857 80.1111V68.6667C77.4464 68.6667 80 66.1096 80 62.9444V5.72222C80 2.55712 77.4464 0 74.2857 0H68.5714H17.1429ZM17.1429 68.6667H62.8571V80.1111H17.1429C13.9821 80.1111 11.4286 77.554 11.4286 74.3889C11.4286 71.2238 13.9821 68.6667 17.1429 68.6667ZM22.8571 25.75C22.8571 24.1764 24.1429 22.8889 25.7143 22.8889H60C61.5714 22.8889 62.8571 24.1764 62.8571 25.75C62.8571 27.3236 61.5714 28.6111 60 28.6111H25.7143C24.1429 28.6111 22.8571 27.3236 22.8571 25.75ZM25.7143 34.3333H60C61.5714 34.3333 62.8571 35.6208 62.8571 37.1944C62.8571 38.7681 61.5714 40.0556 60 40.0556H25.7143C24.1429 40.0556 22.8571 38.7681 22.8571 37.1944C22.8571 35.6208 24.1429 34.3333 25.7143 34.3333Z" />
          </svg>

          <span class="text-center my-4 text-primary text-lg font-semibold">{{ "PARECER_AUDITOR.TITULO" | transloco
            }}</span>
          <span class="text-justify text-primary text-lg">{{ "module.landingPage.acompanhamentoMContinuaDescription" |
            transloco }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção Texto/Imagem 1 -->
  <div class="px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 z-2">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center py-6 md:mb-8 md:py-8">
      <!-- Imagem -->
      <div class="w-full mb-6 md:mb-0">
        <div pAnimateOnScroll [enterClass]="'animate__animated animate__fadeIn'" [leaveClass]="'animate__fadeOut'"
          style="animation-delay: 300ms;">
          <img src="/images/landing/planaction.png" alt="" class="w-full" />
        </div>
      </div>
      <!-- Texto -->
      <div class="w-full flex flex-col gap-4 items-center md:items-start text-center md:text-left">
        <span class="text-primary block font-medium text-5xl mb-3">{{
          "menu.auditoria.jornadaAuditor.escopoJornada.label" | transloco }}</span>
        <span class="text-primary block font-normal text-xl mb-5 text-justify">{{
          "module.landingPage.escopoJornadaDetails" | transloco }}</span>
      </div>
    </div>
  </div>

  <!-- Seção Texto/Imagem 2 -->
  <div class="px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 z-2">
    <!-- Ajustado grid-cols e gap -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center py-6 md:mb-8 md:py-8">
      <!-- Texto (Order ajustada) -->
      <div
        class="w-full flex flex-col gap-4 items-center md:items-start text-center md:text-left order-last lg:order-first">
        <span class="text-primary block font-medium text-5xl mb-3">{{
          "menu.auditoria.jornadaAuditor.gerenciamentoAuditoria.label" | transloco }}</span>
        <span class="text-primary block font-normal text-xl mb-5 text-justify">{{
          "module.landingPage.gerenciamentoAuditoriaDetails" | transloco }}</span>
      </div>
      <!-- Imagem (Order ajustada) -->
      <div class="w-full mb-6 md:mb-0 order-first lg:order-last">
        <div pAnimateOnScroll [enterClass]="'animate__animated animate__fadeIn'" [leaveClass]="'animate__fadeOut'"
          style="animation-delay: 400ms;">
          <img src="/images/landing/416d7d403f621bea0e0c0573a8c572ab.png" alt="" class="w-full" />
        </div>
      </div>
    </div>
  </div>

  <!-- Seção Texto/Imagem 3 -->
  <div class="px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 z-2">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center py-6 md:mb-8 md:py-8">
      <!-- Imagem -->
      <div class="w-full mb-6 md:mb-0">
        <div pAnimateOnScroll [enterClass]="'animate__animated animate__fadeIn'" [leaveClass]="'animate__fadeOut'"
          style="animation-delay: 500ms;">
          <img src="/images/landing/7d8ec7cda25560cb64cac66ca03deb77.png" alt="" class="w-full" />
        </div>
      </div>
      <!-- Texto -->
      <div class="w-full flex flex-col gap-4 items-center md:items-start text-center md:text-left">
        <span class="text-primary block font-medium text-5xl mb-3">{{ "PARECER_AUDITOR.TITULO" |
          transloco}}</span>
        <span class="text-primary block font-normal text-xl mb-5 text-justify">{{
          "module.landingPage.escopoJornadaDetails" | transloco }}</span>
      </div>
    </div>
  </div>


  <!-- Footer -->
  <div class="footer bg-primary text-white">
    <!-- Call to Action -->
    <div class="flex flex-col items-center pt-8"> <!-- Adicionado pt-8 -->
      <span class="block font-medium text-4xl mb-2 mt-8 text-center">{{
        "module.landingPage.moreInformationQuestion" | transloco }}
      </span>
      <!-- Botão Footer Convertido -->
      <button
        class="button mb-4 mt-2 flex justify-center items-center bg-surface rounded-[3.4rem] px-6 py-3 w-73 text-center shadow-shine text-primary text-xl font-medium border-0 hover:bg-gray-light transition-colors">
        <!-- Link com estilo Tailwind -->
        <a href="https://iatec.com/pt/fale-conosco/" target="_blank" rel="noopener noreferrer"
          class="text-gray-dark no-underline">{{
          'general.singular.clicHere' | transloco }}</a>
      </button>
    </div>

    <!-- Informações do Footer -->
    <div class="mx-4 px-0 lg:px-4 z-2">
      <!-- Ajustado grid-cols e gap -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 justify-between mb-6 md:mb-6 py-6">
        <!-- Adicionado py-6 e gap -->

        <!-- Copyright -->
        <div class="w-full md:col-span-1 flex flex-col gap-0 items-center md:items-start text-center md:text-left">
          <!-- Removidas classes customizadas não estilizadas -->
          <span class="mb-3">{{'module.landingPage.copyright' | transloco }}</span>
          <span>{{'module.landingPage.developedBy' | transloco }}</span>
        </div>

        <!-- Contato -->
        <div class="w-full md:col-span-1 flex flex-col gap-2 items-center md:items-start text-left mt-4 md:mt-0">

          <div class="flex flex-row gap-3 mb-1 items-center">
            <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="fill-white">
              <path
                d="M3 2C2.17031 2 1.5 2.67031 1.5 3.5V5.37031L10.6688 12.0922C11.4609 12.6734 12.5391 12.6734 13.3312 12.0922L22.5 5.37031V3.5C22.5 2.67031 21.8297 2 21 2H3ZM1.5 7.23125V15.5C1.5 16.3297 2.17031 17 3 17H21C21.8297 17 22.5 16.3297 22.5 15.5V7.23125L14.2172 13.3016C12.8953 14.2672 11.1 14.2672 9.78281 13.3016L1.5 7.23125ZM0 3.5C0 1.84531 1.34531 0.5 3 0.5H21C22.6547 0.5 24 1.84531 24 3.5V15.5C24 17.1547 22.6547 18.5 21 18.5H3C1.34531 18.5 0 17.1547 0 15.5V3.5Z" />
            </svg>
            <!-- Link com estilo Tailwind -->
            <p><a href="mailto:{{'module.landingPage.mailToIatec' | transloco }}"
                class="text-white no-underline">{{'module.landingPage.mailToIatec'
                | transloco }}</a></p>
          </div>

          <div class="flex flex-row gap-3 mb-1 items-center">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="fill-white">
              <path
                d="M20.4054 3.9875C18.1607 1.7375 15.1714 0.5 11.9946 0.5C5.4375 0.5 0.101786 5.83571 0.101786 12.3929C0.101786 14.4875 0.648214 16.5339 1.6875 18.3393L0 24.5L6.30536 22.8446C8.04107 23.7929 9.99643 24.2911 11.9893 24.2911H11.9946C18.5464 24.2911 24 18.9554 24 12.3982C24 9.22143 22.65 6.2375 20.4054 3.9875ZM11.9946 22.2875C10.2161 22.2875 8.475 21.8107 6.95893 20.9107L6.6 20.6964L2.86071 21.6768L3.85714 18.0286L3.62143 17.6536C2.63036 16.0786 2.11071 14.2625 2.11071 12.3929C2.11071 6.94464 6.54643 2.50893 12 2.50893C14.6411 2.50893 17.1214 3.5375 18.9857 5.40714C20.85 7.27679 21.9964 9.75714 21.9911 12.3982C21.9911 17.8518 17.4429 22.2875 11.9946 22.2875ZM17.4161 14.8839C17.1214 14.7339 15.6589 14.0161 15.3857 13.9196C15.1125 13.8179 14.9143 13.7696 14.7161 14.0696C14.5179 14.3696 13.95 15.0339 13.7732 15.2375C13.6018 15.4357 13.425 15.4625 13.1304 15.3125C11.3839 14.4393 10.2375 13.7536 9.08571 11.7768C8.78036 11.2518 9.39107 11.2893 9.95893 10.1536C10.0554 9.95536 10.0071 9.78393 9.93214 9.63393C9.85714 9.48393 9.2625 8.02143 9.01607 7.42679C8.775 6.84821 8.52857 6.92857 8.34643 6.91786C8.175 6.90714 7.97679 6.90714 7.77857 6.90714C7.58036 6.90714 7.25893 6.98214 6.98571 7.27679C6.7125 7.57679 5.94643 8.29464 5.94643 9.75714C5.94643 11.2196 7.0125 12.6339 7.15714 12.8321C7.30714 13.0304 9.25179 16.0304 12.2357 17.3214C14.1214 18.1357 14.8607 18.2054 15.8036 18.0661C16.3768 17.9804 17.5607 17.3482 17.8071 16.6518C18.0536 15.9554 18.0536 15.3607 17.9786 15.2375C17.9089 15.1036 17.7107 15.0286 17.4161 14.8839Z" />
            </svg>
            <p>
              <!-- Link com estilo Tailwind -->
              <a href="https://wa.me/{{'module.landingPage.whatsAppIatecDial' | transloco }}" target="_blank"
                rel="noopener noreferrer" class="text-white no-underline">{{'module.landingPage.whatsAppIatec' |
                transloco }}</a>
            </p>
          </div>

          <div class="flex flex-row gap-3 mb-1 items-center">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="fill-white">
              <path
                d="M7.72935 1.65413C7.36842 0.782295 6.4169 0.318252 5.50757 0.566679L1.38275 1.69163C0.567163 1.91662 0 2.65721 0 3.50092C0 15.0973 9.40271 24.5 20.9991 24.5C21.8428 24.5 22.5834 23.9328 22.8084 23.1173L23.9333 18.9924C24.1817 18.0831 23.7177 17.1316 22.8459 16.7707L18.3461 14.8957C17.582 14.577 16.6961 14.7973 16.1758 15.4395L14.2822 17.7503C10.9823 16.1894 8.31057 13.5177 6.7497 10.2178L9.06054 8.32884C9.7027 7.80386 9.923 6.92265 9.60426 6.15862L7.72935 1.65882V1.65413Z" />
            </svg>
            <!-- Link com estilo Tailwind -->
            <p><a href="tel:{{'module.landingPage.phoneIatecDial' | transloco }}" target="_blank"
                rel="noopener noreferrer" class="text-white no-underline">{{'module.landingPage.phoneIatec' | transloco
                }}</a></p>
          </div>

        </div>
        <!-- Coluna Vazia para alinhar o contato ao centro em MD (opcional) -->
        <div class="hidden md:block md:col-span-1"></div>
      </div>
    </div>

  </div>
  <p-toast /> <!-- Componente PrimeNG mantido -->
</div>